import React from 'react';
import { useLocation, Link, Navigate } from 'react-router-dom';
import { CheckCircle, Download, Printer, ChevronRight } from 'lucide-react';
export function OrderConfirmationPage() {
  const location = useLocation();
  const orderData = location.state;
  // If accessed directly without order data, redirect to home
  if (!orderData) {
    return <Navigate to="/" replace data-id="element-1353" />;
  }
  const {
    orderId,
    amount,
    paymentMethod,
    paymentStatus,
    receiptNo,
    date,
    cardLast4
  } = orderData;
  const isPaid = paymentStatus === 'Paid';
  return <div className="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-1354">
      <div className="text-center mb-10" data-id="element-1355">
        <CheckCircle className="mx-auto h-16 w-16 text-green-500 mb-4" data-id="element-1356" />
        <h1 className="text-3xl font-extrabold text-gray-900" data-id="element-1357">
          Order Confirmed!
        </h1>
        <p className="mt-2 text-lg text-gray-600" data-id="element-1358">
          Thank you for your purchase. Your order{' '}
          <span className="font-semibold text-gray-900" data-id="element-1359">{orderId}</span> has
          been received.
        </p>
      </div>

      {isPaid && <div className="bg-white shadow-lg rounded-xl overflow-hidden border border-gray-200 mb-8" data-id="element-1360">
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1361">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-1362">
              Payment Receipt
            </h2>
            <div className="flex space-x-2" data-id="element-1363">
              <button className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-colors" title="Print Receipt" data-id="element-1364">
                <Printer className="h-5 w-5" data-id="element-1365" />
              </button>
              <button className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-colors" title="Download PDF" data-id="element-1366">
                <Download className="h-5 w-5" data-id="element-1367" />
              </button>
            </div>
          </div>

          <div className="p-6 sm:p-8" data-id="element-1368">
            <div className="flex justify-between items-start mb-8" data-id="element-1369">
              <div className="flex items-center gap-3" data-id="element-1370">
                <img src="https://cdn.magicpatterns.com/uploads/6qgM4mDpnqGm6ucRQC8GRZ/Gadgets_Zone_Logo.png" alt="Gadgets Zone" className="h-10 object-contain" data-id="element-1371" />
                <div data-id="element-1372">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-1373">
                    Gadgets Zone
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-1374">
                    contact@gadgetszone.com
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-1375">
                <p className="text-sm font-medium text-gray-500" data-id="element-1376">Receipt No.</p>
                <p className="text-base font-semibold text-gray-900" data-id="element-1377">
                  {receiptNo}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-y-6 gap-x-4 mb-8" data-id="element-1378">
              <div data-id="element-1379">
                <p className="text-sm font-medium text-gray-500" data-id="element-1380">Date & Time</p>
                <p className="text-base text-gray-900" data-id="element-1381">
                  {new Date(date).toLocaleString()}
                </p>
              </div>
              <div data-id="element-1382">
                <p className="text-sm font-medium text-gray-500" data-id="element-1383">Order ID</p>
                <p className="text-base text-gray-900" data-id="element-1384">{orderId}</p>
              </div>
              <div data-id="element-1385">
                <p className="text-sm font-medium text-gray-500" data-id="element-1386">
                  Payment Method
                </p>
                <p className="text-base text-gray-900 flex items-center" data-id="element-1387">
                  {paymentMethod} {cardLast4 && `ending in ${cardLast4}`}
                </p>
              </div>
              <div data-id="element-1388">
                <p className="text-sm font-medium text-gray-500" data-id="element-1389">Status</p>
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 mt-1" data-id="element-1390">
                  {paymentStatus}
                </span>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-6" data-id="element-1391">
              <div className="flex justify-between items-center text-lg font-bold" data-id="element-1392">
                <span className="text-gray-900" data-id="element-1393">Amount Paid</span>
                <span className="text-blue-600" data-id="element-1394">
                  Rs. {amount.toLocaleString()}
                </span>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 px-6 py-4 border-t border-gray-200" data-id="element-1395">
            <div className="flex items-center justify-center text-xs text-gray-500" data-id="element-1396">
              <span data-id="element-1397">Transaction processed securely by</span>
              <img src="https://cdn.magicpatterns.com/uploads/wtigZ1ySqavxJHCJbfDDio/Paysys_Logo.png" alt="Paysys Labs" className="h-4 object-contain ml-2" data-id="element-1398" />
            </div>
          </div>
        </div>}

      {!isPaid && <div className="bg-white shadow rounded-lg p-6 border border-gray-200 mb-8" data-id="element-1399">
          <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1400">
            Order Details
          </h2>
          <div className="space-y-3" data-id="element-1401">
            <div className="flex justify-between" data-id="element-1402">
              <span className="text-gray-500" data-id="element-1403">Payment Method</span>
              <span className="font-medium" data-id="element-1404">{paymentMethod}</span>
            </div>
            <div className="flex justify-between" data-id="element-1405">
              <span className="text-gray-500" data-id="element-1406">Total Amount</span>
              <span className="font-medium" data-id="element-1407">Rs. {amount.toLocaleString()}</span>
            </div>
            <div className="flex justify-between" data-id="element-1408">
              <span className="text-gray-500" data-id="element-1409">Status</span>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-1410">
                {paymentStatus}
              </span>
            </div>
          </div>
        </div>}

      <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1411">
        <Link to="/" className="inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors" data-id="element-1412">
          Continue Shopping
        </Link>
        <Link to="/account" className="inline-flex justify-center items-center px-6 py-3 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors" data-id="element-1413">
          View Order History
        </Link>
      </div>
    </div>;
}